export default "__VITE_ASSET__0fhMfEtP__"